import React from 'react';
import PageHeader from './global-components/page-header';
import BlogList from './blog-components/blog-list';

const BlofPage = () => {
    return <div>
        <PageHeader headertitle="Blog"  />
        <BlogList />
    </div>
}

export default BlofPage

